"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var R = __importStar(require("../../utils/ramda"));
require("./ActionModal.css");
var react_modal_1 = __importDefault(require("react-modal"));
var Row_1 = require("../../components/Row");
var Text_1 = require("../../components/Text");
var Button_1 = require("../../components/Button");
var Stack_1 = require("../../components/Stack");
var MDIcon_1 = require("../../components/MDIcon");
var classnames_1 = __importDefault(require("classnames"));
var ActionModal = function (_a) {
  var _b = _a.isOpen,
    isOpen = _b === void 0 ? false : _b,
    children = _a.children,
    _c = _a.headerText,
    headerText = _c === void 0 ? "" : _c,
    _d = _a.onRequestClose,
    onRequestClose = _d === void 0 ? R.N : _d,
    header = _a.header,
    body = _a.body,
    footer = _a.footer,
    _e = _a.onSubmit,
    onSubmit = _e === void 0 ? R.N : _e,
    _f = _a.submitButtonText,
    submitButtonText = _f === void 0 ? "Save" : _f,
    _g = _a.cancelButtonText,
    cancelButtonText = _g === void 0 ? "Cancel" : _g,
    onCloseIconClick = _a.onCloseIconClick,
    _h = _a.type,
    type = _h === void 0 ? "default" : _h,
    className = _a.className,
    criticalSubmit = _a.criticalSubmit,
    height = _a.height,
    width = _a.width,
    _j = _a.hideHeader,
    hideHeader = _j === void 0 ? false : _j,
    _k = _a.hideFooter,
    hideFooter = _k === void 0 ? false : _k,
    noPad = _a.noPadding,
    restProps = __rest(_a, ["isOpen", "children", "headerText", "onRequestClose", "header", "body", "footer", "onSubmit", "submitButtonText", "cancelButtonText", "onCloseIconClick", "type", "className", "criticalSubmit", "height", "width", "hideHeader", "hideFooter", "noPadding"]);
  var cn = (0, classnames_1.default)("vsx-action-modal", "vsx-action-modal-".concat(type), className);
  return (0, jsx_runtime_1.jsx)(react_modal_1.default, __assign({
    isOpen: isOpen,
    className: cn,
    id: "action-modal",
    ariaHideApp: false,
    overlayClassName: "vsx-action-modal-overlay",
    onRequestClose: function () {
      onRequestClose();
    },
    style: {
      content: {
        height: type === "custom" ? height : undefined,
        width: type === "custom" ? width : undefined
      }
    }
  }, restProps, {
    children: (0, jsx_runtime_1.jsx)(ActionModalContent, {
      noPadding: noPad,
      header: header,
      body: body !== null && body !== void 0 ? body : children,
      footer: footer,
      headerText: headerText,
      submitButtonText: submitButtonText,
      onSubmit: onSubmit,
      cancelButtonText: cancelButtonText,
      onRequestClose: onRequestClose,
      onCloseIconClick: onCloseIconClick,
      type: type,
      criticalSubmit: criticalSubmit,
      hideHeader: hideHeader,
      hideFooter: hideFooter
    })
  }));
};
exports.ActionModal = ActionModal;
var ActionModalHeader = function (_a) {
  var headerText = _a.headerText,
    header = _a.header,
    onCloseIconClick = _a.onCloseIconClick;
  var closeIcon = (0, jsx_runtime_1.jsx)(Row_1.Row, __assign({
    justify: "center",
    align: "center"
  }, {
    children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      icon: "close",
      clickable: true,
      "aria-label": "close",
      onClick: onCloseIconClick,
      size: 20,
      className: "vsx-action-modal-header-close-icon"
    })
  }));
  return (0, jsx_runtime_1.jsx)(Stack_1.Stack, __assign({
    padding: "large",
    className: "vsx-action-modal-header"
  }, {
    children: header ? header : (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      justify: "space-between",
      align: "center",
      className: "vsx-action-modal-header-content"
    }, {
      children: [(0, jsx_runtime_1.jsx)(Text_1.Text, __assign({
        size: 16,
        weight: "medium"
      }, {
        children: headerText
      })), onCloseIconClick != undefined && closeIcon]
    }))
  }));
};
var ActionModalBody = function (_a) {
  var body = _a.body,
    type = _a.type,
    hideHeader = _a.hideHeader,
    hideFooter = _a.hideFooter,
    noPad = _a.noPadding;
  var className = "vsx-action-modal-body-".concat(type);
  var paddingHorizontal = type === "form" ? "2xl" : "large";
  var paddingVertical = type === "form" || type === "custom" && hideHeader || type === "custom" && hideFooter ? "2xl" : "none";
  return (0, jsx_runtime_1.jsx)(Stack_1.Stack, __assign({
    paddingLeft: noPad ? "none" : paddingHorizontal,
    paddingRight: noPad ? "none" : paddingHorizontal,
    paddingTop: noPad ? "none" : paddingVertical,
    paddingBottom: noPad ? "none" : paddingVertical,
    className: (0, classnames_1.default)("vsx-action-modal-body", className)
  }, {
    children: body ? body : (0, jsx_runtime_1.jsx)(Stack_1.Stack, {})
  }));
};
var ActionModalFooter = function (_a) {
  var footer = _a.footer,
    onSubmit = _a.onSubmit,
    submitButtonText = _a.submitButtonText,
    cancelButtonText = _a.cancelButtonText,
    onRequestClose = _a.onRequestClose,
    criticalSubmit = _a.criticalSubmit;
  return (0, jsx_runtime_1.jsx)(Stack_1.Stack, __assign({
    padding: "large",
    className: "vsx-action-modal-footer"
  }, {
    children: footer ? footer : (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      gap: "medium",
      justify: "end"
    }, {
      children: [(0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
        onClick: onRequestClose,
        type: "tertiary",
        uppercase: true
      }, {
        children: cancelButtonText
      })), (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
        onClick: onSubmit,
        type: criticalSubmit ? "critical" : "primary",
        uppercase: true
      }, {
        children: submitButtonText
      }))]
    }))
  }));
};
var ActionModalContent = function (_a) {
  var header = _a.header,
    body = _a.body,
    footer = _a.footer,
    headerText = _a.headerText,
    onSubmit = _a.onSubmit,
    submitButtonText = _a.submitButtonText,
    cancelButtonText = _a.cancelButtonText,
    onRequestClose = _a.onRequestClose,
    onCloseIconClick = _a.onCloseIconClick,
    criticalSubmit = _a.criticalSubmit,
    type = _a.type,
    hideHeader = _a.hideHeader,
    hideFooter = _a.hideFooter,
    noPad = _a.noPadding;
  var className = "vsx-action-modal-content-".concat(type);
  if (type === "custom") {
    if (hideHeader && !hideFooter) {
      className = "".concat(className, "-hide-header");
    }
    if (hideHeader && hideFooter) {
      className = "".concat(className, "-hide-header-footer");
    }
  }
  var showHeader = type !== "loading" && type !== "form" && (type !== "custom" || type === "custom" && !hideHeader);
  var showFooter = type !== "notification" && type !== "loading" && (type !== "custom" || type === "custom" && !hideFooter);
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: (0, classnames_1.default)("vsx-action-modal-content", className)
  }, {
    children: [showHeader && (0, jsx_runtime_1.jsx)(ActionModalHeader, {
      headerText: headerText,
      header: header,
      onCloseIconClick: onCloseIconClick
    }), (0, jsx_runtime_1.jsx)(ActionModalBody, {
      noPadding: noPad,
      body: body,
      type: type,
      hideHeader: hideHeader,
      hideFooter: hideFooter
    }), showFooter && (0, jsx_runtime_1.jsx)(ActionModalFooter, {
      footer: footer,
      criticalSubmit: criticalSubmit,
      onSubmit: onSubmit,
      submitButtonText: submitButtonText,
      cancelButtonText: cancelButtonText,
      onRequestClose: onRequestClose
    })]
  }));
};